import React, { FC, ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import i18next from 'i18next';
import { Grid } from '@material-ui/core';
import { DateRange, Whatshot, AccessTime, Search, SvgIconComponent } from '@material-ui/icons';
import { useStyles } from './styles';
import useIsUserLoggedIn from '../../../../config/hooks/useIsUserLoggedIn';

interface Props {
    isMobile?: boolean;
}

const Menu: FC<Props> = ({ isMobile }) => {
    const classes = useStyles({ isMobile });
    const isUserLoggedIn = useIsUserLoggedIn();

    const renderMenuItem = (label: string, to: string, MenuItemIcon: SvgIconComponent): ReactElement => (
        <Grid item className={classes.menuItem}>
            <NavLink to={to} key={label} className={classes.link} activeClassName={classes.activeLink}>
                <Grid container direction={isMobile ? 'row' : 'column'} alignItems="center">
                    <Grid item>
                        <MenuItemIcon className={classes.icon} />
                    </Grid>
                    <Grid item>
                        <span className={classes.linkText}>{i18next.t(label)}</span>
                    </Grid>
                </Grid>
            </NavLink>
        </Grid>
    );

    return (
        <Grid container className={classes.container}>
            {renderMenuItem('MenuViewerComponentDiscover', '/', Whatshot)}
            {renderMenuItem('MenuViewerComponentSearch', '/search', Search)}

            {isUserLoggedIn && (
                <>
                    {renderMenuItem('MenuViewerComponentLiveEvent', '/live_events', DateRange)}
                    {renderMenuItem('MenuViewerComponentRequests', '/message/private_request', AccessTime)}
                </>
            )}
        </Grid>
    );
};

export default Menu;
